// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".IncomeAndExpenditure-wrapper .table-title[data-v-1daef367] {\n  font-weight: 600;\n  font-size: 18px;\n  margin: 20px 0;\n}\n.info-row[data-v-1daef367] {\n  background: blue;\n}", ""]);
// Exports
module.exports = exports;
